const CLOSE_SVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><line x1="2" y1="2" x2="14" y2="14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><line x1="14" y1="2" x2="2" y2="14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`;

class AccordionDrawer {
  #overlay;
  #panel;
  #titleEl;
  #bodyEl;

  constructor() {
    this.#createElements();
    this.#bindTriggers();
  }

  #createElements() {
    this.#overlay = document.createElement('div');
    this.#overlay.className = 'accordion-drawer__overlay';
    this.#overlay.setAttribute('aria-hidden', 'true');
    this.#overlay.addEventListener('click', () => this.close());

    this.#panel = document.createElement('div');
    this.#panel.className = 'accordion-drawer';
    this.#panel.setAttribute('role', 'dialog');
    this.#panel.setAttribute('aria-modal', 'true');
    this.#panel.setAttribute('aria-hidden', 'true');
    this.#panel.innerHTML = `
      <div class="accordion-drawer__header">
        <span class="accordion-drawer__title"></span>
        <button class="accordion-drawer__close" type="button" aria-label="Close">${CLOSE_SVG}</button>
      </div>
      <div class="accordion-drawer__body"></div>
    `;

    this.#titleEl = this.#panel.querySelector('.accordion-drawer__title');
    this.#bodyEl = this.#panel.querySelector('.accordion-drawer__body');
    this.#panel.querySelector('.accordion-drawer__close').addEventListener('click', () => this.close());

    document.body.append(this.#overlay, this.#panel);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  #bindTriggers() {
    document.querySelectorAll('[data-drawer-accordion] .details__header').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.#open(summary);
      });
    });
  }

  #open(summary) {
    const details = summary.closest('.details');
    const source = details.querySelector('.details-content');

    // Extract title from text nodes only (skip icon/svg spans)
    const title = Array.from(summary.childNodes)
      .filter((n) => n.nodeType === Node.TEXT_NODE)
      .map((n) => n.textContent.trim())
      .filter(Boolean)
      .join(' ');

    this.#titleEl.textContent = title;
    this.#bodyEl.innerHTML = '';
    this.#bodyEl.appendChild(source.cloneNode(true));

    this.#overlay.classList.add('is-open');
    this.#panel.classList.add('is-open');
    this.#panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('accordion-drawer-open');

    this.#panel.querySelector('.accordion-drawer__close').focus();
  }

  close() {
    if (!this.#panel.classList.contains('is-open')) return;
    this.#overlay.classList.remove('is-open');
    this.#panel.classList.remove('is-open');
    this.#panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('accordion-drawer-open');
  }
}

if (document.querySelector('[data-drawer-accordion]')) {
  new AccordionDrawer();
}
